import styled from "styled-components";

import { theme } from "../../styles/theme";

export const DisableValueText = styled.span`
  ${theme.text};
  color: #b3b3b3;
`;
